import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

interface LinkQueryProps {
  to: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const LinkWithQuery: FunctionComponent<LinkQueryProps> = ({
  children,
  disabled,
  to,
  className,
  onClick,
  ...props
}) => {
  // Remove all routing/onClick functionality if anchor is disabled
  if (disabled) {
    return (
      <a
        className={cn(className, 'quoteorderbar__customise--disabled')}
        href=""
        data-testid="customise-button"
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      className={className}
      to={to}
      onClick={onClick}
      data-testid="customise-button"
      {...props}
    >
      {children}
    </Link>
  );
};
